import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { FetchOrders } from '../exact.actions';
import { ExactState } from '../exact.state';

@Component({
    selector: 'app-exact-orders',
    templateUrl: './exact-orders.component.html',
    styleUrls: ['./exact-orders.component.scss'],
})
export class ExactOrdersComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    @Select(ExactState.loggedIn) loggedIn$: Observable<boolean>;
    @Select(ExactState.orders) orders$: Observable<any[]>;
    filter: string;
    isset = true;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.loggedIn$.subscribe((loggedIn) => {
                if (loggedIn) {
                    this.store.dispatch(new FetchOrders()).subscribe();
                }
            }),
        );
    }

    checkCredentials(set: boolean) {
        this.isset = set;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
